import styles from "./footer.module.scss";

export default function Footer() {
  return (
    <div className={styles.footer}>
      <span className={styles.footerText}>
        &copy; {new Date().getFullYear()} Tapestry AI. All rights reserved
      </span>
    </div>
  );
}
